<template>
  <DefaultLayout>
    <div slot="content">
      <template v-if="!loading">
        <template v-for="rq in requests">
          <ProfileView
            :requestId="rq.profile.id"
            :requestLoad="rq"
            :propertyTabId="$route.query.propertyTabId"
            :propertyTabReference="$route.query.propertyTabReference"
            :key="rq.profile.id"
          ></ProfileView>
        </template>
        <template v-for="rq in linkedLoadedReq">
          <!-- <v-divider :key="rq.profile.id" class="mt-5 mb-3"></v-divider> -->
          <ProfileView
            :requestId="rq.profile.id"
            :requestLoad="rq"
            :propertyTabId="$route.query.propertyTabId"
            :propertyTabReference="$route.query.propertyTabReference"
            :key="rq.profile.id"
          ></ProfileView>
        </template>
        <template
          v-if="
            linkedRequests && linkedRequests.length && linkedRequests.length > 0 && !linkedLoaded
          "
        >
          <!-- <v-divider class="mt-5 mb-5"></v-divider> -->
          <div style="display: flex; align-items: center; justify-content: center">
            <v-btn
              depressed
              color="grey lighten-3"
              :loading="linkedloading"
              @click="loadLinkedRequests"
              class="mt-4"
            >
              Display all user related data requests
            </v-btn>
          </div>
        </template>
      </template>
      <template v-else>
        <v-skeleton-loader
          class="mx-auto"
          type="list-item-avatar, divider, list-item-three-line, card-heading, image"
        ></v-skeleton-loader>
      </template>
    </div>
  </DefaultLayout>
</template>

<script>
import { mapState } from 'vuex';
import DefaultLayout from '@/layouts/DefaultLayout';
import ProfileView from '@/components/ProfileView';

import { GET_REQUEST } from '@/store/actions.type';

export default {
  name: 'profile-request',
  components: {
    DefaultLayout,
    ProfileView
  },
  data() {
    return {
      loading: false,
      requests: [],
      linkedLoadedReq: [],
      linkedRequests: [],
      linkedLoaded: false,
      linkedloading: false
    };
  },
  computed: {
    ...mapState({ organization: (state) => state.organizations.userSelectedOrganization }),
    requestId() {
      return this.$route.params.id;
    }
  },
  watch: {},
  methods: {
    async loadLinkedRequests() {
      this.linkedloading = true;
      for await (var req of this.linkedRequests.map((rq) =>
        this.$store.dispatch(GET_REQUEST, rq.profileId)
      )) {
        if (req.profile.status === 8 && !this.organization.purgedRequests) {
          continue;
        } else {
          this.linkedLoadedReq.push(req);
        }
      }
      this.linkedloading = false;
      this.linkedLoaded = true;
    }
  },
  async mounted() {
    this.loading = true;
    try {
      var req = await this.$store.dispatch(GET_REQUEST, this.requestId);
      this.loading = false;
      this.requests.push(req);
      this.linkedRequests = req.profile.linkedProfiles;
    } catch (err) {
      this.$notify({
        type: 'error',
        title: 'Error',
        text: 'Error loading request data. Please contact support@planetverify.com'
      });
      this.loading = false;
    }
  }
};
</script>
